import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import { ArrowLink } from 'site-modules/shared/components/arrow-link/arrow-link';
import { HelpfulTipsCard } from 'site-modules/shared/components/helpful-tips-card/helpful-tips-card';

import './helpful-tips-module.scss';

export function HelpfulTipsModule({ content, className = null, dataTrackingParent, withTracking = false }) {
  const title = content.title;
  const seeMoreContent = content.child('more-articles-link');
  const seeMoreLinkText =
    seeMoreContent.metadata('link-text').value() || content.metadata('moreLinkText').value() || 'See more';
  const seeMoreUrl = seeMoreContent.metadata('link-url').value() || content.metadata('moreLink').value();
  const contentEntries = content.children().filter(child => child.id !== 'more-articles-link');

  return (
    <div className={classnames('helpful-tips-module', className)} data-tracking-parent={dataTrackingParent}>
      <h2 className="heading-3 mb-1_5">{title}</h2>
      <div className="background-light-gray-lg p-lg-1 row">
        {contentEntries.map((article, index) => (
          <Fragment key={article.id}>
            <HelpfulTipsCard content={article} className="col-12 col-md-3 col-lg-12" withTracking={withTracking} />
            {(index !== contentEntries.length - 1 || !!seeMoreUrl) && <hr className="col-11 my-1" />}
          </Fragment>
        ))}
        {!!seeMoreUrl && (
          <ArrowLink
            className="mt-0 mt-md-1_5 mt-lg-0 col-12"
            to={seeMoreUrl}
            {...(withTracking && {
              'data-tracking-id': 'see_more_articles',
              'data-tracking-value': seeMoreLinkText,
            })}
          >
            {seeMoreLinkText}
          </ArrowLink>
        )}
      </div>
    </div>
  );
}

HelpfulTipsModule.propTypes = {
  className: PropTypes.string,
  content: CmsEntities.Content.isRequired,
  dataTrackingParent: PropTypes.string,
  withTracking: PropTypes.bool,
};
